import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GraduationCap } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonDigited } from "../Button/Button.variants";
import { ModalBasic } from "../ModalBasic";

interface MarkAsCompletedConfirmModalProps {
  course: CourseItem | null;
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
}

export const MarkAsCompletedConfirmModal: React.FC<MarkAsCompletedConfirmModalProps> = ({
  course,
  isLoading,
  onCancel,
  onConfirm,
  open
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <ModalBasic
      open={ open }
      title={ "" }
      handleClose={ onCancel }
      size={ { height: "auto", maxHeight: "90vh", width: { sm: "34rem", xs: "100vw" } } }
      content={
        <Box
          sx={ {
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
            textAlign: "center",
            width: "100%"
          } }
        >
          <Typography
            variant="h5"
            fontWeight={ 700 }
            color={ theme.customColors.textPrimary }
          >
            { t("mark_completed_confirm_title") }
          </Typography>

          <Box
            sx={ {
              display: "flex",
              flexDirection: "column",
              gap: "1rem"
            } }
          >
            <Typography
              variant="body1"
              color={ theme.customColors.textPrimary }
            >
              { t("mark_completed_confirm_message") }
            </Typography>

            <Box
              sx={ {
                alignItems: "center",
                color: theme.customColors.textPrimary,
                display: "flex",
                gap: "0.5rem",
                justifyContent: "center"
              } }
            >
              <GraduationCap size={ 20 } style={ { flexShrink: 0 } } />
              <Typography
                variant="body1"
                fontWeight={ 700 }
              >
                { course?.title }
              </Typography>
            </Box>
          </Box>

          <Divider sx={ { borderColor: theme.customColors.border } } />

          <Box
            sx={ {
              display: "flex",
              flexWrap: "wrap",
              gap: "1rem",
              justifyContent: "center"
            } }
          >
            <ButtonDigited
              typology="secondary"
              onClick={ onCancel }
              text={ t("annul") }
              disabled={ isLoading }
            />
            <ButtonDigited
              typology="primary"
              onClick={ onConfirm }
              disabled={ isLoading }
            >
              <>
                { isLoading && <CircularProgress size={ 16 } color="inherit" /> }
                <span>{ t("confirm") }</span>
              </>
            </ButtonDigited>
          </Box>
        </Box>
      }
    />
  );
};
